import { useEffect, useState } from 'react';
import { api } from '../api';

export default function Formas() {
  const [formas, setFormas] = useState([]);
  const [msg, setMsg] = useState(null);

  const carregar = () => api('/formas').then(setFormas).catch(e => setMsg({ t: 'erro', m: e.message }));
  useEffect(() => { carregar(); }, []);

  const subir = async (numero, arquivo, descricao) => {
    setMsg(null);
    try {
      const form = new FormData();
      if (arquivo) form.append('imagem', arquivo);
      if (descricao !== undefined) form.append('descricao', descricao);
      await api(`/formas/${numero}`, { method: 'PUT', form });
      setMsg({ t: 'ok', m: `Forma ${numero} atualizada.` });
      carregar();
    } catch (e) { setMsg({ t: 'erro', m: e.message }); }
  };

  // Garante os slots 1..9 mesmo se ainda não existirem no banco
  const slots = Array.from({ length: 9 }, (_, i) => {
    const n = i + 1;
    return formas.find(f => f.numero === n) || { numero: n, descricao: '', imagem_url: null };
  });

  return (
    <div>
      <h2 style={{ marginBottom: 6 }}>Formas de Armação</h2>
      <p style={{ color: 'var(--cinza)', marginTop: 0, marginBottom: 14, fontSize: 13.5 }}>
        Suba aqui os PNGs dos 9 desenhos que aparecem na ficha de OS das lojas.
      </p>
      {msg && <div className={msg.t === 'ok' ? 'sucesso' : 'erro'} style={{ marginBottom: 12 }}>{msg.m}</div>}

      <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))' }}>
        {slots.map(f => (
          <div key={f.numero} className="card">
            <div className="row" style={{ justifyContent: 'space-between', marginBottom: 8 }}>
              <strong style={{ color: 'var(--verde)' }}>Forma {f.numero}</strong>
            </div>
            <div style={{
              height: 80, border: '1px dashed var(--linha)', borderRadius: 6,
              display: 'grid', placeItems: 'center', marginBottom: 10, background: '#fafbfb',
            }}>
              {f.imagem_url
                ? <img src={f.imagem_url} alt={`Forma ${f.numero}`} style={{ maxHeight: 70, maxWidth: '95%' }} />
                : <span style={{ fontSize: 12.5, color: 'var(--cinza)' }}>Sem imagem</span>}
            </div>
            <input className="input" placeholder="Descrição (ex.: Aviador)" defaultValue={f.descricao || ''}
              onBlur={e => e.target.value !== (f.descricao || '') && subir(f.numero, null, e.target.value)}
              style={{ marginBottom: 8 }} />
            <label className="btn-sec" style={{ display: 'block', textAlign: 'center' }}>
              {f.imagem_url ? 'Substituir PNG' : 'Enviar PNG'}
              <input type="file" accept="image/png,image/jpeg,image/svg+xml" hidden
                onChange={e => e.target.files[0] && subir(f.numero, e.target.files[0])} />
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
